import { InteractionType } from "@azure/msal-browser";
import { MsalAuthenticationTemplate } from "@azure/msal-react";
import React, { ReactNode } from "react";
import { apiRequest } from "./Auth/AuthConfig";
import Logout from "./Pages/Logout";

interface AuthenticatedRouteProps {
  children: ReactNode;
}

const isEmbeddedApp = () => {
  try {
    const searchParams = new URLSearchParams(window.location.search);
    const embeddingParam =
      searchParams.get("embedding") || searchParams.get("embedded");

    return (
      window.self !== window.top ||
      window.location.pathname.toLowerCase().includes("/embedding") ||
      embeddingParam === "true" ||
      embeddingParam === "1"
    );
  } catch {
    return true;
  }
};

const AuthenticatedRoute: React.FC<AuthenticatedRouteProps> = ({ children }) => {
  const embedded = isEmbeddedApp();

  return (
    <MsalAuthenticationTemplate
      interactionType={
        embedded ? InteractionType.Silent : InteractionType.Redirect
      }
      authenticationRequest={apiRequest}
      errorComponent={Logout}
    >
      {children}
    </MsalAuthenticationTemplate>
  );
};

export default AuthenticatedRoute;